export { SuiAccordionModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/accordion/public.js
// module id = 1095
// module chunks = 0